import moment from 'moment';
import React, { useState } from 'react';
import { Helpers } from '../../../helpers/Helpers';
import { GetDeviceDataListForMapResponseItem } from '../../../models/response/deviceData/GetDeviceDataListForMapResponse';
import { GetDeviceHistoryBetweenTwoDatesResponseItem } from '../../../models/response/deviceDataHistory/GetDeviceHistoryBetweenTwoDatesResponse';
import Flatpickr from "react-flatpickr";
import { FocusObj, GeneralStateModel } from '../Map';

export interface VehicleDetailHistoryModel {
    startDate: Date
    endDate: Date
}

interface Props {
    focusedDeviceId: string | null | undefined
    data: VehicleDetailHistoryModel | undefined
    isShown: boolean
    setVehicleDetailHistory: React.Dispatch<React.SetStateAction<VehicleDetailHistoryModel | undefined>>
    getDeviceHistory: () => void
    getData: (_isOneTime: boolean, _focusObj: FocusObj | undefined) => Promise<void>
    historyIndex: number
    historyData: GetDeviceHistoryBetweenTwoDatesResponseItem[]
    setHistoryIndex: React.Dispatch<React.SetStateAction<number>>
    setGeneralState: React.Dispatch<React.SetStateAction<GeneralStateModel>>
    setHistoryData: React.Dispatch<React.SetStateAction<GetDeviceHistoryBetweenTwoDatesResponseItem[]>>
    setFocusedDeviceId: React.Dispatch<React.SetStateAction<string | null | undefined>>
    isDebug: boolean
}

const VehicleDetailHistory = ({
    isShown,
    data,
    focusedDeviceId,
    setVehicleDetailHistory,
    getDeviceHistory,
    getData,
    historyIndex,
    historyData,
    setHistoryIndex,
    setGeneralState,
    setHistoryData,
    setFocusedDeviceId,
    isDebug
}: Props) => {
    const [currentInterval, setCurentInterval] = useState<NodeJS.Timer | undefined>(undefined);
    const [currentIntervalSpeed, setCurrentIntervalSpeed] = useState(1);

    const autoPlay = () => {
        setCurentInterval(
            setInterval(() => {
                setHistoryData((_historyData) => {
                    setHistoryIndex((_index) => {
                        if ((_index + 1) == _historyData.length) {
                            setCurentInterval((_currentInterval) => {
                                if (_currentInterval) {
                                    clearInterval(_currentInterval);
                                    _currentInterval = undefined;
                                }

                                return _currentInterval;
                            })

                            return _index;
                        }

                        moveHistoryMarker(_index + 1)
                        return _index + 1;
                    })

                    return _historyData;
                })
            }, (1000 / currentIntervalSpeed))
        );
    }

    const pauseAutoPlay = () => {
        if (currentInterval) {
            clearInterval(currentInterval);
            setCurentInterval(undefined);
        }
    }

    const onCloseClicked = () => {
        if (currentInterval) {
            clearInterval(currentInterval);
            setCurentInterval(undefined);
        }

        setHistoryData([])
        setHistoryIndex(0)
        setFocusedDeviceId(undefined)
        setVehicleDetailHistory(undefined);

        getData(true, { deviceId: undefined, type: 'CLOSE' });
    }

    const onGoBackClicked = () => {
        if (currentInterval) {
            clearInterval(currentInterval);
            setCurentInterval(undefined);
        }

        setHistoryData([])
        setHistoryIndex(0)
        setVehicleDetailHistory(undefined);

        getData(true, undefined);
    }

    const moveHistoryMarker = (newVal: number) => {
        setGeneralState((_generalState) => {
            if (newVal > 0 && _generalState.____tMarkers.length == 1) {
                _generalState.____tMarkers[0].setPosition(new google.maps.LatLng(historyData[newVal].latitude, historyData[newVal].longitude), true);
                _generalState.____tMarkers[0].setIcon({
                    url: Helpers.getEndpoint() + (`/markers/arrow-${historyData[newVal].statusColor}-${historyData[newVal].directionDegree}.png`),
                    scaledSize: new google.maps.Size(20, 20),
                    anchor: new google.maps.Point(10, 10),
                });
            }
            else {
                _generalState.____tMarkers.forEach((item: any) => {
                    item.setMap(null)
                })

                _generalState.____tMarkers = [];

                var _m = new google.maps.Marker({
                    map: _generalState.____tMap,
                    icon: {
                        url: Helpers.getEndpoint() + (`/markers/arrow-${historyData[newVal].statusColor}-${historyData[newVal].directionDegree}.png`),
                        scaledSize: new google.maps.Size(20, 20),
                        anchor: new google.maps.Point(10, 10),
                    },
                    position: new google.maps.LatLng(historyData[newVal].latitude, historyData[newVal].longitude),
                });

                _generalState.____tMarkers.push(_m);
            }

            _generalState.____tMap.panTo(new google.maps.LatLng(historyData[newVal].latitude, historyData[newVal].longitude));

            return _generalState;
        })
    }

    const nextHistory = () => {
        if ((historyIndex + 1) == historyData.length)
            return;

        var newVal = historyIndex + 1;
        moveHistoryMarker(newVal);
        setHistoryIndex(newVal);
    }

    const previousHistory = () => {
        if (historyIndex == 0)
            return;

        var newVal = historyIndex - 1;
        moveHistoryMarker(newVal);
        setHistoryIndex(newVal);
    }

    return (
        <React.Fragment>
            {
                (isShown && focusedDeviceId && data) && (
                    <div style={{ overflow: 'hidden', width: '20%', position: 'absolute', right: '15px', height: 'calc(100% - 30px)', top: '15px' }} className="menu menu-sub menu-sub-dropdown show">
                        <div className="d-flex" style={{ flexDirection: 'column', flex: 1 }}>
                            <div style={{ width: '100%' }} className="d-flex flex-grow-1">
                                <div className='d-flex' style={{ flexDirection: 'column', width: '100%', flex: 1 }}>
                                    <div className="p-3">
                                        <div className="d-flex">
                                            <div className="d-flex flex-grow-1 align-items-center">
                                                <h4 style={{ lineHeight: 1 }} className="m-0">Araç Geçmişi</h4>
                                            </div>
                                            <div className="d-flex">
                                                <i onClick={onCloseClicked} style={{ fontSize: 24 }} className="actionIcon fa fa-times" />
                                            </div>
                                        </div>
                                    </div>

                                    <hr className="m-0" />

                                    <div className="p-3">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Başlangıç Tarihi</label>
                                            <Flatpickr
                                                value={data.startDate}
                                                onChange={([date]) => {
                                                    setVehicleDetailHistory({ ...data, startDate: date })
                                                }}
                                                options={{
                                                    enableTime: true,
                                                    dateFormat: "d.m.Y H:i",
                                                    time_24hr: true,
                                                    locale: {
                                                        weekdays: {
                                                            longhand: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
                                                            shorthand: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt']
                                                        },
                                                        months: {
                                                            longhand: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
                                                            shorthand: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara']
                                                        },
                                                    }
                                                }}
                                                className='form-control form-control-solid'
                                                placeholder='Tarih Seçiniz'
                                                lang='tr'
                                            />
                                            {/* <input value={data.startDate} onChange={(e) => setVehicleDetailHistory({ ...data, startDate: e.target.value })} type="date" className="form-control form-control-solid" /> */}
                                        </div>



                                        <div className='mt-5'>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Bitiş Tarihi</label>
                                            {/* <input value={data.endDate} onChange={(e) => setVehicleDetailHistory({ ...data, endDate: e.target.value })} type="date" className="form-control form-control-solid" /> */}
                                            <Flatpickr
                                                value={data.endDate}
                                                onChange={([date]) => {
                                                    setVehicleDetailHistory({ ...data, endDate: date })
                                                }}
                                                options={{
                                                    enableTime: true,
                                                    dateFormat: "d.m.Y H:i",
                                                    time_24hr: true,
                                                    locale: {
                                                        weekdays: {
                                                            longhand: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
                                                            shorthand: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt']
                                                        },
                                                        months: {
                                                            longhand: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
                                                            shorthand: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara']
                                                        },
                                                    }
                                                }}
                                                className='form-control form-control-solid'
                                                placeholder='Tarih Seçiniz'
                                                lang='tr'
                                            />
                                        </div>

                                        <div className='mt-5' style={{ textAlign: 'right' }}>
                                            <button onClick={onGoBackClicked} style={{ marginRight: 10 }} className='btn btn-danger btn-sm'>Geri</button>
                                            <button onClick={getDeviceHistory} className='btn btn-primary btn-sm'>Sorgula</button>
                                        </div>
                                    </div>



                                    {
                                        (historyData && historyData.length > 0) && (
                                            <React.Fragment>
                                                <hr className='m-0' />

                                                <div className='d-flex flex-grow-1 p-3'>
                                                    <div className='card' style={{ width: '100%' }}>
                                                        <div className='p-3 card-body'>
                                                            <div style={{ flexDirection: 'column', height: '100%' }} className='d-flex'>
                                                                <div style={{ flexDirection: 'column' }} className='d-flex flex-grow-1'>
                                                                    <div>
                                                                        <span style={{ fontWeight: 'bold' }} className='d-block'>Tarih</span>
                                                                        <span className='d-block'>{historyData[historyIndex].gpsDateTime} - {historyData[historyIndex].createdDate}</span>
                                                                    </div>

                                                                    {
                                                                        isDebug && (
                                                                            <div className='mt-3'>
                                                                                <span style={{ fontWeight: 'bold' }} className='d-block'>historyIndex</span>
                                                                                <span className='d-block'>{historyIndex}</span>
                                                                            </div>
                                                                        )
                                                                    }

                                                                    <div className='mt-3'>
                                                                        <span style={{ fontWeight: 'bold' }} className='d-block'>Adres</span>
                                                                        <span className='d-block'>{historyData[historyIndex].location}</span>
                                                                    </div>

                                                                    <div className='mt-3'>
                                                                        <span style={{ fontWeight: 'bold' }} className='d-block'>Anlık Hız</span>
                                                                        <span className='d-block'>{historyData[historyIndex].kmPerHour} km/s</span>
                                                                    </div>

                                                                    <div className='mt-3'>
                                                                        <span style={{ fontWeight: 'bold' }} className='d-block'>Aktif Sürücü</span>
                                                                        <span className="d-block">{Helpers.isEmpty(historyData[historyIndex].cardDriverNameSurname) ? '-' : historyData[historyIndex].cardDriverNameSurname}</span>
                                                                        <span className='d-block'>{historyData[historyIndex].cardDriverRfid}</span>
                                                                        <span className='d-block'>{historyData[historyIndex].cardDriverRfidDate}</span>
                                                                    </div>

                                                                    <div className='mt-3'>
                                                                        <span style={{ fontWeight: 'bold' }} className='d-block'>Günlük Km</span>
                                                                        <span className='d-block'>{historyData[historyIndex].totalKmDaily.toFixed(0)} km</span>
                                                                    </div>
                                                                </div>

                                                                <div className='d-flex mt-3'>
                                                                    <div className='flex-grow-1 d-flex'>&nbsp;</div>

                                                                    <div style={{ opacity: currentInterval ? 0.25 : 1 }} onClick={!currentInterval ? previousHistory : undefined} className='d-flex'>
                                                                        <i style={{ fontSize: 36 }} className='actionIcon fa fa-chevron-left' />
                                                                    </div>
                                                                    <div onClick={currentInterval ? pauseAutoPlay : autoPlay} style={{ marginRight: 30, marginLeft: 30 }} className='d-flex'>
                                                                        <i style={{ fontSize: 36 }} className={`actionIcon fa fa-${currentInterval ? 'pause' : 'play'}`} />
                                                                    </div>
                                                                    <div style={{ opacity: currentInterval ? 0.25 : 1 }} onClick={!currentInterval ? nextHistory : undefined} className='d-flex'>
                                                                        <i style={{ fontSize: 36 }} className='actionIcon fa fa-chevron-right' />
                                                                    </div>

                                                                    <div className='flex-grow-1 d-flex'>&nbsp;</div>
                                                                </div>

                                                                <div style={{ gap: '0.75rem' }} className='d-flex mt-5'>
                                                                    {
                                                                        [1, 2, 3, 4, 5].map((item, index) =>
                                                                            <div onClick={!currentInterval ? () => setCurrentIntervalSpeed(item) : undefined} style={{ opacity: currentInterval ? 0.25 : 1, fontWeight: 600, border: '1px solid #99A1B7', color: currentIntervalSpeed == item ? '#fff' : '#99A1B7', background: currentIntervalSpeed == item ? '#99A1B7' : undefined, borderRadius: 4 }} className='actionIcon d-flex flex-grow-1 justify-content-center py-1'>
                                                                                {item}x
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </React.Fragment >
    )
}

export default VehicleDetailHistory;